export const messages = {
  en: {
    inspectionItemManage: {
      searchCondition: 'Search Condition',
      itemIdPlaceholder: 'Please enter item number',
      itemNamePlaceholder: 'Please enter inspection item',
      searchBtn: 'Search',
      resetBtn: 'Reset',
      inspectionItems: 'Inspection Items',
      doc: 'Document',
      addBtn: 'Add',
      id: 'ID',
      itemName: 'Inspection Item',
      createTime: 'Create Time',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      question: 'Inspection Questions',
      addTitle: 'Add',
      editTitle: 'Edit',
      deleteTitle: 'Delete',
      itemNameLabel: 'Inspection Item',
      remarkLabel: 'Remark',
      requiredItem: 'Required, please fill in inspection item',
      requiredRemark: 'Required, please fill in remark',
      save: 'Save',
      cancel: 'Cancel',
      confirmDelete: 'Confirm deletion?',
      confirmDeleteMsg: 'Are you sure to delete the inspection item?',
      cancelDelete: 'Cancel',
      confirmDeleteBtn: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      itemDetail: 'Item Detail',
      noItemSelected: 'Please select an inspection item on the left'
    }
  },
  zh: {
    inspectionItemManage: {
      searchCondition: '查询条件',
      itemIdPlaceholder: '请输入项目编号',
      itemNamePlaceholder: '请输入巡检项目',
      searchBtn: '查询',
      resetBtn: '重置',
      inspectionItems: '巡检项目',
      doc: '文档',
      addBtn: '添加',
      id: '编号',
      itemName: '巡检项目',
      createTime: '创建时间',
      remark: '备注',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      question: '巡检题目',
      addTitle: '添加',
      editTitle: '修改',
      deleteTitle: '删除',
      itemNameLabel: '巡检项目',
      remarkLabel: '备注',
      requiredItem: '必填，请填写巡检项目',
      requiredRemark: '必填，请填写备注',
      save: '保存',
      cancel: '取消',
      confirmDelete: '请确认您的操作',
      confirmDeleteMsg: '确定删除巡检项目',
      cancelDelete: '点错了',
      confirmDeleteBtn: '确认删除',
      deleteSuccess: '删除成功',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      itemDetail: '巡检项目详情',
      noItemSelected: '请在左侧选择一个巡检项目'
    }
  },
  'zh-TW': {
    inspectionItemManage: {
      searchCondition: '查詢條件',
      itemIdPlaceholder: '請輸入項目編號',
      itemNamePlaceholder: '請輸入巡檢項目',
      searchBtn: '查詢',
      resetBtn: '重設',
      inspectionItems: '巡檢項目',
      doc: '文檔',
      addBtn: '添加',
      id: '編號',
      itemName: '巡檢項目',
      createTime: '創建時間',
      remark: '備註',
      operation: '操作',
      edit: '修改',
      delete: '刪除',
      question: '巡檢題目',
      addTitle: '添加',
      editTitle: '修改',
      deleteTitle: '刪除',
      itemNameLabel: '巡檢項目',
      remarkLabel: '備註',
      requiredItem: '必填，請填寫巡檢項目',
      requiredRemark: '必填，請填寫備註',
      save: '保存',
      cancel: '取消',
      confirmDelete: '請確認您的操作',
      confirmDeleteMsg: '確定刪除巡檢項目',
      cancelDelete: '點錯了',
      confirmDeleteBtn: '確認刪除',
      deleteSuccess: '刪除成功',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      itemDetail: '巡檢項目詳情',
      noItemSelected: '請在左側選擇一個巡檢項目'
    }
  }
}